
  document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('customer-service-button');
    const layer = document.getElementById('customer-service-layer');

    let isHovered = false;
    let timeout;

    function positionLayer() {
      const rect = button.getBoundingClientRect();
      layer.style.position = 'absolute';
      layer.style.top = rect.bottom + window.scrollY + 'px';
      layer.style.left = rect.left + window.scrollX + 'px';
      layer.style.display = 'block';
      layer.style.opacity = '1';
      layer.style.zIndex = 9999;
    }

    function showLayer() {
      clearTimeout(timeout);
      isHovered = true;
      positionLayer();
    }

    function hideLayer() {
      isHovered = false;
      timeout = setTimeout(() => {
        if (!isHovered) {
          layer.style.display = 'none';
          layer.style.opacity = '0';
        }
      }, 200); // gecikme süresi, yumuşak geçiş için
    }

    button.addEventListener('mouseenter', showLayer);
    button.addEventListener('mouseleave', hideLayer);
    layer.addEventListener('mouseenter', showLayer);
    layer.addEventListener('mouseleave', hideLayer);
  });

